import type { EstabelecimentoItem, EstabelecimentoOption } from "../../../services/estabelecimentosAplicativo"

export type { EstabelecimentoItem, EstabelecimentoOption }

export type EstabelecimentosAplicativoModel = {
    estabelecimentosDoApp: EstabelecimentoItem[]
    todosEstabelecimentos: EstabelecimentoOption[]
    idParaAdicionar: number | null
    podeEditar: boolean
}

export const EstabelecimentosAplicativoInicial: EstabelecimentosAplicativoModel = {
    estabelecimentosDoApp: [],
    todosEstabelecimentos: [],
    idParaAdicionar: null,
    podeEditar: true,
}
